enum FastTagsLoaderNames {
  ShopifyStatus = "shopifyStatus",
  WalmartKeys = "walmartKeys",
  Next = "next",
}

export default FastTagsLoaderNames;
